import { combineReducers } from 'redux'

import { CAREPLANS_RECEIVED } from './actions'

const allIds = (state = [], action) => {
  const { type, payload } = action
  switch (type) {
    case CAREPLANS_RECEIVED:
      if (payload == null) throw new Error('No carePlans')
      return [...payload.map(carePlan => carePlan.identifier[0].value)]
    default:
      return state
  }
}

const byId = (state = {}, action) => {
  const { type, payload } = action
  switch (type) {
    case CAREPLANS_RECEIVED:
      return payload.reduce(
        (s, carePlan) => ({
          ...s,
          [carePlan.identifier[0].value]: carePlan
        }),
        {}
      )
    default:
      return state
  }
}

export default combineReducers({
  allIds,
  byId
})

export const getAllCarePlans = state =>
  state.careplans.allIds.map(id => state.careplans.byId[id])

export const getAllCarePlansFromPatientId = (state, patientId) =>
  getAllCarePlans(state).filter(
    carePlan =>
      (carePlan.subject != null &&
        (carePlan.subject.identifier != null &&
          carePlan.subject.identifier.value) === patientId) ||
      carePlan.subject.reference === patientId
  )

export const getActiveCareplansFromPatientId = (state, patientId) =>
  getAllCarePlansFromPatientId(state, patientId).filter(
    carePlan =>
      carePlan.period != null &&
      carePlan.period.end != null &&
      Date.parse(carePlan.period.end) > Date.parse(new Date())
  )



// WEBPACK FOOTER //
// ./src/Careplan/ducks.js